import { Checkbox } from "primereact/checkbox";
import {
  subNumCountingCapital,
  toSentenceCase,
} from "../../../utils/constants";
import { Button } from "primereact/button";
import { getRandomizeBlockItems } from "../../../utils/commonLogics";

const ShowTQItemHeading = ({
  taskQues,
  index,
  handleCheckboxSelection,
  isLocked,
  cloneSingleTaskQuestionAt,
  showLogicDialog,
  showConfirm,
  taskQuestion,
  subIndex = 0, // used for Randomization block
}) => {
  const actualIndex = index + subIndex;
  const getRandomizeBlocks = getRandomizeBlockItems(taskQuestion);
  return (
    <div className="d-flex align-items-center justify-content-between">
      <div className="d-flex align-items-center">
        {taskQues?.type !== "randomization_block" ? (
          <Checkbox
            inputId={`${taskQues.type}-${actualIndex}`}
            checked={taskQues.isSelected}
            onChange={(e) =>
              handleCheckboxSelection(actualIndex, taskQues.type, e.checked)
            }
            disabled={isLocked}
          />
        ) : (
          ""
        )}
        <label
          htmlFor={`category-${actualIndex}`}
          className={taskQues?.type === "randomization_block" ? "" : "ms-2"}
        >
          {taskQues?.type === "randomization_block" ? (
            ""
          ) : (
            <span className="me-1">{actualIndex + 1}.</span>
          )}
          {taskQues?.type === "randomization_block" ? (
            `Randomization Block ${subNumCountingCapital[getRandomizeBlocks?.findIndex((randomizeBlock) => randomizeBlock?.bId === taskQues?.bId) || 0]}`
          ) : (
            <>
              {toSentenceCase(taskQues.type)}:
              {taskQues?.isExtraction ? (
                <span className="d-inline-flex align-items-center gap-1">
                  {" "}
                  (<i className="pi pi-arrow-right" />{" "}
                  <i className="pi pi-bars" /> Extracted From: Q
                  {taskQuestion.findIndex(
                    (item) =>
                      item?.qId === taskQues?.extractedQId ||
                      item?.question_id === taskQues?.extractedQId,
                  ) + 1}
                  )
                </span>
              ) : (
                ""
              )}
            </>
          )}
        </label>
      </div>
      <div className="d-flex align-items-center">
        {(taskQues.type === "task" && taskQues?.subTaskQues?.length > 0) ||
        taskQues?.type === "randomization_block" ? (
          ""
        ) : (
          <>
            <i className="pi pi-cog"></i>
            <Button
              className="fw-bold px-2"
              link
              onClick={() => showLogicDialog(actualIndex)}
              disabled={taskQuestion.length - 1 === actualIndex || isLocked}
            >
              Logic
            </Button>
            <span className="me-2">|</span>
          </>
        )}

        <i className="pi pi-clone"></i>
        <Button
          className="fw-bold px-2"
          link
          onClick={() => cloneSingleTaskQuestionAt(actualIndex, taskQues?.type)}
          disabled={isLocked}
        >
          Clone
        </Button>

        <span className="me-2">|</span>

        <i className="pi pi-trash"></i>
        {/* send deleteType task for Task/Question both because individual task is also part of task. */}
        <Button
          className="fw-bold px-2"
          link
          onClick={() =>
            showConfirm(
              actualIndex,
              taskQues.type === "randomization_block" ? "block" : "task",
              taskQues.type === "randomization_block"
                ? taskQues?.block_id
                : taskQues.type === "task"
                  ? taskQues?.task_id
                  : taskQues?.task_id,
            )
          }
          disabled={isLocked}
        >
          Delete
        </Button>
      </div>
    </div>
  );
};

export default ShowTQItemHeading;
